export default {
  methods: {
    safe_array_get(arr, idx) {
      if (!Array.isArray(arr)) return undefined;
      return Reflect.get(arr, idx);
    },

    safe_array_set(arr, idx, value) {
      if (!Array.isArray(arr)) return false;
      return Reflect.set(arr, idx, value);
    },

    safe_obj_get(obj, key) {
      if (!obj || typeof obj !== 'object') return undefined;
      return Reflect.get(obj, key);
    },
  },
};
